import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { seedDevAuthToken } from "@/lib/auth/token-provider";
import { initPostHog } from "@/lib/posthog";
import { initSentry } from "@/lib/sentry";
import { App } from "./App";
import "./index.css";

const LOCAL_HOSTS = ["localhost", "127.0.0.1", "[::1]", "::1", ""];
const isLocalhost = LOCAL_HOSTS.includes(window.location.hostname);

// VITE_SENTRY / VITE_POSTHOG are set only in production; localhost is
// excluded as a safety net.
if (import.meta.env.VITE_SENTRY === "true" && !isLocalhost) {
  initSentry();
}
if (import.meta.env.VITE_POSTHOG === "true" && !isLocalhost) {
  initPostHog();
}

// Must run before React first reads the token.
seedDevAuthToken();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
